function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16C12.3765 16 16 12.3765 16 8C16 3.63137 12.3686 0 7.99216 0C3.62353 0 0 3.63137 0 8C0 12.3765 3.63137 16 8 16ZM6.92549 12.0235C6.65882 12.0235 6.44706 11.9059 6.22745 11.6392L3.96078 8.84706C3.84314 8.69804 3.77255 8.5098 3.77255 8.33726C3.77255 7.96863 4.06275 7.68628 4.41569 7.68628C4.63529 7.68628 4.83137 7.77255 5.01177 8.01569L6.88627 10.4392L10.5333 4.59608C10.6824 4.35294 10.8863 4.23529 11.098 4.23529C11.4431 4.23529 11.7725 4.46275 11.7725 4.83922C11.7725 5.01176 11.6706 5.2 11.5765 5.35686L7.58431 11.6392C7.41177 11.898 7.19216 12.0235 6.92549 12.0235Z",
  fill: "#0A0A22"
});

function SvgIconCheckCircleFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircleFilled);
export default __webpack_public_path__ + "static/media/icon-check-circle-filled.00bf336f.svg";
export { ForwardRef as ReactComponent };